import { cacheExchange, createClient, fetchExchange } from "@urql/core";
import { registerUrql } from "@urql/next/rsc";
import { env } from "./env";

export function getSubdomain(url: string | null) {
  if (!url) {
    return null;
  }

  let domain: string | undefined = url;

  if (url.includes("://")) {
    domain = url.split("://").at(1);
  }

  if (domain?.includes("localhost")) {
    return domain.split(".").at(0);
  }

  if (domain?.split(".").length === 3) {
    return domain.split(".").at(0);
  }

  return null;
}

export function getDomain(url: string | null) {
  if (!url) {
    return null;
  }

  let domain: string | undefined = url;

  if (url.includes("://")) {
    domain = url.split("://").at(1);
  }

  if (domain?.split(".").length === 3) {
    return domain.split(".").slice(1, 3).join(".");
  }

  return domain;
}

export function buildPath() {
  return "/landing";
}

/////////////////////////////////////////////////////////////////////
// Change hex color into RGB /////////////////////////////////////////////////////////////////////
export const getRGBColor = (type: string, hex: string) => {
  let color = hex.replace(/#/g, "");
  // rgb values
  var r = parseInt(color.substr(0, 2), 16);
  var g = parseInt(color.substr(2, 2), 16);
  var b = parseInt(color.substr(4, 2), 16);

  return {
    cssString: `--color-${type}: ${r}, ${g}, ${b};`,
    key: `--color-${type}`,
    value: `${r}, ${g}, ${b}`,
  };
};

/////////////////////////////////////////////////////////////////////
// Determine the accessible color of text
/////////////////////////////////////////////////////////////////////
export const getAccessibleColor = (hex: string) => {
  let color = hex.replace(/#/g, "");
  // rgb values
  var r = parseInt(color.substr(0, 2), 16);
  var g = parseInt(color.substr(2, 2), 16);
  var b = parseInt(color.substr(4, 2), 16);
  var yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? "#000000" : "#FFFFFF";
};
